// extracted by mini-css-extract-plugin
module.exports = {"dataCell":"ContactsTable_dataCell__3LlD7","headerCell":"ContactsTable_headerCell__2URQz","ellipseCell":"ContactsTable_ellipseCell__p2WeG","tooltip":"ContactsTable_tooltip__3r7bO"};